module.exports = __webpack_public_path__ + "static/media/icone_add_imagem.2e5d76b5.png";